import styled from 'styled-components';
import { Button } from 'antd';

export const Toolbar = styled.div`
  background-color: #2d2d2d;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1000;
  overflow: hidden;
  max-height: ${({ $visible }) => ($visible ? '80px' : '0')};
  opacity: ${({ $visible }) => ($visible ? '1' : '0')};
  transition: max-height 0.3s ease, opacity 0.25s ease;

  @media (max-width: 768px) {
    max-height: ${({ $visible }) => ($visible ? '350px' : '0')};
  }

  @media print {
    display: none;
  }
`;

export const Container = styled.div`
  max-width: 1580px;
  margin-inline: auto;
  padding-inline: 35px;
  padding-block: 12px;

  @media (max-width: 768px) {
    max-width: none;
    padding: 12px 16px;
  }
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
`;

export const Btn = styled(Button)`
  && {
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
    height: auto;
    padding: 8px 16px;
    transition: all 0.3s ease;
    border-radius: 4px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    .anticon {
      font-size: 18px;
    }

    &:hover {
      background-color: transparent !important;
      color: #ffffff !important;
    }

    &:disabled {
      color: rgba(255, 255, 255, 0.3) !important;
      cursor: not-allowed;
    }

    @media (max-width: 768px) {
      padding: 10px 0;
      width: 100%;
      justify-content: space-between;
    }
  }
`;

export const ResetBtn = styled(Btn)`
  && {
    padding-left: 0;

    @media (max-width: 768px) {
      order: 4;
    }
  }
`;

export const ContrastBtn = styled(Btn)`
  && {
    @media (max-width: 768px) {
      order: 2;
    }
  }
`;

export const CloseBtn = styled(Btn)`
  && {
    padding-right: 0;

    @media (max-width: 768px) {
      order: 5;
      border-top: 1px solid rgba(255, 255, 255, 0.15);
      padding-top: 12px;
      margin-top: 4px;
    }
  }
`;

export const SizeGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;

  @media (max-width: 768px) {
    order: 3;
    width: 100%;
    justify-content: space-between;
  }
`;

export const SizeLabel = styled.span`
  color: #ffffff;
  font-size: 16px;
  font-weight: 400;
`;

export const SizeButtonGroup = styled.div`
  display: flex;
  gap: 4px;
`;

export const SizeBtn = styled(Button)`
  && {
    color: #ffffff;
    font-size: 18px;
    font-weight: 400;
    height: auto;
    padding: 8px;
    transition: all 0.3s ease;
    border-radius: 4px;
    min-width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    .anticon {
      font-size: 18px;
    }

    &:hover {
      background-color: transparent !important;
      color: #ffffff !important;
    }

    &:disabled {
      color: rgba(255, 255, 255, 0.3) !important;
      cursor: not-allowed;
    }

    @media (max-width: 768px) {
      padding: 10px 0;
      min-width: 0;
      width: auto;
      height: auto;
      border-radius: 4px;

      .anticon {
        font-size: 18px;
      }
    }
  }
`;
